import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }                         from '../api/api.service';
import { ConfirmService }                     from '../messages/confirm/confirm.service';
import { DealersTermsAndConditionsComponent } from './dealers.terms-and-conditions.component';
import { SessionService }                     from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class DealersService {
  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  grantAccess ( code : string ) : Promise<any> {
    if ( !code ) {
      return Promise.reject(this.translateService.instant('JS_SPACE.DEALER.ENTER_CODE'));
    }

    return this.apiService.get('/company/find_dealer_details', code)
      .then(( details : any ) => {
        if ( details.company.branding_group === 'bosch' ) {
          const modal = this.modalService.open(DealersTermsAndConditionsComponent, {
            windowClass: 'lg-modal'
          });

          modal.componentInstance.settings = details.settings;

          return modal.result;
        } else {
          return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.AUTHORISE_DEALER', {
              name: details.company.company_name
            }));
        }
      })
      .then(() => this.apiService.get('/company/grant_dealer_access', code))
      .then(() => this.sessionService.refresh());
  }

  revokeAccess () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REVOKE_DEALER'))
      .then(() => this.apiService.get('/company/revoke_dealer_access'));
  }
}
